(() => {
  function initialise(scope) {
    scope.querySelectorAll('.byob:not([data-byob-ready])').forEach(page => {
      page.dataset.byobReady = 'true';
      const navLinks = [...page.querySelectorAll('.byob-nav a')];
      function markCurrent(id) {
        navLinks.forEach(link => {
          if (link.hash === '#' + id) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }
      page.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#byob-"]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = page.querySelector(link.hash);
        if (!target) return;
        event.preventDefault();
        if (link.hasAttribute('data-byob-gift')) {
          const choice = page.querySelector('input[name="byob-recipient"][value="gift"]');
          if (choice) {
            choice.checked = true;
            choice.dispatchEvent(new Event('change', {bubbles: true}));
          }
        }
        target.focus({preventScroll: true});
        target.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
        // Local file previews may reject history changes; navigation still works.
        try { history.replaceState(null, '', link.hash); } catch (_) {}
        markCurrent(target.id);
      });
      const sections = [...page.querySelectorAll('section[id]')];
      let scrollQueued = false;
      function updateLocation() {
        scrollQueued = false;
        const nav = page.querySelector('.byob-nav');
        const marker = Math.max(0, nav.getBoundingClientRect().top) + nav.offsetHeight + 100;
        const passed = sections.filter(section => section.getBoundingClientRect().top <= marker);
        markCurrent(passed.length ? passed[passed.length - 1].id : '');
      }
      function queueLocation() {
        if (scrollQueued) return;
        scrollQueued = true;
        requestAnimationFrame(updateLocation);
      }
      window.addEventListener('scroll', queueLocation, {passive: true});
      window.addEventListener('resize', queueLocation);
      updateLocation();
    });
  }
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
